import { LoadingBox } from "@src/components/elements/LoadingBox";
import React from "react";
import styled from "styled-components/macro";

const StyledDiv = styled.div`
  margin: 3rem;
`;

const HrSyncLoading: React.FC = () => {
  return (
    <StyledDiv>
      <LoadingBox
        description={"Importing HR data..."}
        header={"Connecting to your HRIS"}
      />
    </StyledDiv>
  );
};

export default HrSyncLoading;
